<template>
  <div class="candidate-modal-documents">
    <input
      ref="fileUploadInput"
      type="file"
      multiple
      :accept="acceptedFileFormats"
      class="hidden"
      @change="onFileUpload"
    />
    <div class="candidate-modal-documents__actions">
      <div v-if="noFilesExists" class="no-files">Файлов пока нет</div>
      <c-button
        v-if="!noFilesExists"
        label="Скачать одним архивом"
        icon="download"
        size="small"
        :responsive="true"
        @click="downloadAllDocuments"
      />
      <c-button
        label="Добавить файл"
        :icon="{ icon: 'plus', color: 'primary' }"
        size="small"
        :disabled="disableFileUploadButton"
        :responsive="true"
        @click="$refs.fileUploadInput.click()"
      />
    </div>
    <div class="candidate-modal-documents__files">
      <viewer v-if="appendedFiles.length" :images="appendedFiles.map((i) => i.url)">
        <file-template-component
          v-for="(file, fileIndex) in appendedFiles"
          :key="`file-${fileIndex}`"
          :file="file"
          :file-index="fileIndex"
          @remove-image="removeImage(file.name, fileIndex)"
        />
      </viewer>
    </div>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";
import FileTemplateComponent from "@/components/file-template-component";
import { downloadDocument } from "@/utils/download";

const acceptedFileFormats = [".jpg", ".png", ".gif", ".doc", ".docx", ".pdf"];

export default {
  name: "candidate-modal-documents",
  components: {
    FileTemplateComponent,
    "c-button": Button,
  },
  props: {
    candidateFiles: {
      type: Array,
      default: () => [],
    },
    candidateId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      appendedFiles: [],
      form: {
        files: [],
      },
      acceptedFileFormats,
    };
  },
  computed: {
    noFilesExists() {
      return this.appendedFiles.length === 0;
    },
    disableFileUploadButton() {
      return this.appendedFiles.length === 10;
    },
  },
  created() {
    if (this.candidateFiles.length) {
      this.candidateFiles.forEach((file) => {
        const format = file.split(".").pop();
        this.appendedFiles.push({
          name: file.split(`.${format}`).shift(),
          url: `/upload/${file}`,
          format,
        });
      });
    }
  },
  methods: {
    removeImage(name, index) {
      const fileName = `${this.appendedFiles[index].name}.${this.appendedFiles[index].format}`;

      this.$store.dispatch("candidates/deleteFile", { fileName, candidateId: this.candidateId });

      this.appendedFiles.splice(index, 1);

      const b = this.form.files.findIndex((file) => file.name === name);

      if (b !== -1) {
        this.form.files.splice(b, 1);
      }
    },
    onFileUpload(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }

      const newFileList = Array.from(files);
      newFileList.forEach((file, index) => {
        if (file.size > 10000000) {
          newFileList.splice(index, 1);
          this.$notify({
            group: "file-error-message",
            data: {
              textMessage: "Размер файла не должен превышать 5мб",
            },
          });
          return;
        }
        this.form.files.push(file);
      });
      document.querySelector("input[type=file]").value = "";

      this.$store.dispatch("candidates/uploadFile", { files: newFileList, candidateId: this.candidateId });

      this.createImage(newFileList);
    },
    createImage(files) {
      for (let index = 0; index < files.length; index++) {
        const reader = new FileReader();
        reader.onload = (event) => {
          const { name } = files[index];
          const url = event.target.result;
          const format = name.split(".").pop();
          if (this.appendedFiles.length < 20) {
            this.appendedFiles.push({ url, name, format });
          }
        };
        reader.readAsDataURL(files[index]);
      }
    },
    async downloadAllDocuments() {
      const url = await this.$store.dispatch("candidates/downloadAllFiles", this.candidateId);
      downloadDocument(url, `Документы кандидата #${this.candidateId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";

.candidate-modal-documents {
  &__actions {
    display: flex;
    justify-content: flex-end;
    margin-left: auto;
    margin-bottom: 26px;
    gap: 10px;
  }
  &__files > div {
    display: flex;
    flex-wrap: wrap;
    gap: 37px 20px;
  }
}

.no-files {
  font-size: 15px;
  color: $color-label;
  margin-right: auto;
}
.hidden {
  display: none;
}
</style>
